import type { ToolInvocation } from '@ai-sdk/ui-utils';
import { memo } from 'react';
import { ToolCallText } from './ToolCallText';
import { useDetailsDialog } from '~/components/chat/assistant-message/context';
import { Button } from '~/components/ui/Button';

interface ToolCallProps {
  toolInvocation: ToolInvocation;
  isPending?: boolean;
}

export const ToolCall = memo(({ toolInvocation, isPending }: ToolCallProps) => {
  const { openDetailsDialog } = useDetailsDialog();

  return (
    <Button
      variant="ghost"
      truncate={false}
      size="md"
      className="w-full flex items-start gap-2 py-2 hover:bg-transparent px-0 group/button text-left h-auto relative"
      onClick={() => openDetailsDialog(btoa(toolInvocation.toolCallId))}
    >
      <ToolCallText toolInvocation={toolInvocation} isPending={isPending} />

      <div className="flex-1"></div>

      <span className="mt-0.5 opacity-0 bg-gradient-to-r from-transparent via-25% via-bolt-elements-background-depth-1 to-bolt-elements-background-depth-1 pl-8 pr-1 absolute right-0 group-hover/button:opacity-100 font-normal text-size-xs transition-[opacity,transform] duration-200 text-bolt-ds-brand">
        <div className="flex items-center">
          <span>Open</span>
          <span className="inline-block i-ph:caret-right text-bolt-ds-brand size-3 shrink-0 ml-1" />
        </div>
      </span>
    </Button>
  );
});
